module.exports = __webpack_public_path__ + "img/wechat_qrcode.14c09596.png";